"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.benefits.precise_interactions': 'Resolución precisa y rápida de interacciones con clientes, garantizando alta calidad y eficiencia.',
    'onboarding.benefits.customer_satisfaction': 'Maximizar los indicadores de Satisfacción del Cliente a través de un servicio mejorado e instantáneo.',
    'onboarding.benefits.workflow_automation': 'Automatización integral de flujos de trabajo clave, llevando a una reducción significativa en costos operativos y liberación de recursos humanos.',
    'onboarding.benefits.real_time_insights': 'Uso efectivo de datos en tiempo real para generar perspectivas profundas y impulsar el crecimiento empresarial sostenible.',
};
